var _style, _path, _g, _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitaminDDeficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6393D;}\n\t.st1{fill:#EFC05D;}\n\t.st2{fill:#F6D99E;}\n\t.st3{opacity:0;clip-path:url(#SVGID_2_);fill}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97.7,138.3 85.1,146.2 83.4,131.4 68.6,133 73.4,118.9 59.4,114 69.9,103.4 59.4,92.8 73.4,87.9  68.6,73.8 83.4,75.4 85.1,60.6 97.7,68.5 105.7,55.9 113.7,68.5 126.3,60.6 128.1,75.4 142.8,73.8 138,87.9 152,92.8 141.5,103.4  152,114 138,118.9 142.9,133 128.1,131.4 126.3,146.2 113.7,138.3 105.7,150.9  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 105.7,
    cy: 103.4,
    r: 24.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaminDDeficiency);
export default __webpack_public_path__ + "static/media/Vitamin_D_Deficiency.4c455e6c41f2c8a52155a6100048b9a9.svg";
export { ForwardRef as ReactComponent };